// extracted by mini-css-extract-plugin
module.exports = {"root":"_e07a883","image":"_5dff6a1"};